 <!-- home white lable wise login modal -->
<div class="logindiv" *ngIf="!loginFreeplay && !signUpPage">
	<img class="img-fluid" src="assets/img/{{env.host.name}}/logo.png">

	<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
	  <div class="form-group">
		<input type="email" formControlName="username" class="form-control" id="" placeholder="Enter Username...">
		<div *ngIf="submitted && f.username.errors" class="invalid-feedback">
			<div *ngIf="f.username.errors.required">The User Name field is required</div>
		</div>
	  </div>
	  <div class="form-group">
		<input type="password" formControlName="password" class="form-control" id="" placeholder="Password...">
		<div *ngIf="submitted && f.password.errors" class="invalid-feedback">
			<div *ngIf="f.password.errors.required">The Password field is required</div>
		</div>
	  </div>
	  <div class="form-check">
		<input type="checkbox" class="form-check-input" id="exampleCheck1">
		<label class="form-check-label" for="exampleCheck1">Check me out</label>
	  </div>
	  <div class="fp-ps" *ngIf="env.host.signUpActive" (click)="openResetPassModal(forgotPasswordModal)"> forgot Password?</div>
	  <button type="submit" class="btn btn-login" [disabled]="isLoad">Submit
		<i *ngIf="!isLoad" class="mdi mdi-logout-variant"></i>
		<i *ngIf="isLoad" class="mdi mdi-spin mdi-loading"></i>
	  </button>
	  <button class="btn btn-login" [disabled]="isLoadDemo" (click)="loginWIthDemoId()">Demo Login
		<i *ngIf="!isLoadDemo" class="mdi mdi-logout-variant"></i>
		<i *ngIf="isLoadDemo" class="mdi mdi-spin mdi-loading"></i>
	  </button>

	  <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/betfair-logo.png">
	</form>
</div>
<!-- home white lable wise login modal -->


<!-- home freeplay login modal -->
<div class="modal-header" *ngIf="loginFreeplay && !signUpPage">
	<h5 class="modal-title">Welcome to {{env.host.name | titlecase}}</h5>
	<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body" *ngIf="loginFreeplay && !signUpPage">
	<div class="login-block">
	  <div class="container">
		<div class="row">
		  <div class="col-md-12 login-sec">
			  <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
				<img src="assets/img/{{env.host.name}}/logo.png" alt="logo" class="modal_logo">
				<div class="form-group">
					<label>Username</label>
					<div class="input-group">
						<div class="input-group-append">
							<span class="input-group-text"><i class="fa fa-user"></i></span>
						</div>
						<input type="text" formControlName="username" class="form-control" placeholder="Username">
						<div *ngIf="submitted && f.username.errors" class="invalid-feedback">
							<div *ngIf="f.username.errors.required">The User Name field is required</div>
						</div>
					</div>       
				</div>

				<div class="form-group">
				  <label>Password</label>
				  <div class="input-group">
						<div class="input-group-append">
							<span class="input-group-text"><i class="fa fa-lock"></i></span>
						</div>
						<input id="passwordIpt" type="password" formControlName="password" class="form-control" placeholder="Password">
						<div *ngIf="submitted && f.password.errors" class="invalid-feedback">
							<div *ngIf="f.password.errors.required">The Password field is required</div>
						</div>
						<a class="eye-pass" (click)="togglePasscode()">
							<i *ngIf="passType" class="fa fa-eye-slash"></i>
							<i *ngIf="!passType" class="fa fa-eye"></i>
						</a>
				  </div>
				</div>
				<a href="javascript:void(0);" class="forget" (click)="openResetPassModal(forgotPasswordModal)">forget password?</a>
				<button type="submit" class="btn modalLoginbtn mb-1" [disabled]="isLoad">Login Now
					<i *ngIf="!isLoad" class="mdi mdi-logout-variant"></i>
					<i *ngIf="isLoad" class="mdi mdi-spin mdi-loading"></i>
				</button>
				<button type="button" class="btn modalLoginbtn" [disabled]="isLoadDemo" (click)="loginWIthDemoId()">Demo Login
					<i *ngIf="!isLoadDemo" class="mdi mdi-logout-variant"></i>
					<i *ngIf="isLoadDemo" class="mdi mdi-spin mdi-loading"></i>
				</button>
				<p>
					Do not have an account?
					<a class="link" href="javascript:void(0);" routerLink="/signup" (click)="bsModalRef.hide()">Sign Up now!
					</a>
				</p>
			  </form>
		  </div>
		</div>
	  </div>
  </div>

</div>
<!-- home freeplay login modal -->



<div class="modal-body p-0"  *ngIf="key?.signUpModal || signUpPage">
<!-- <button *ngIf="key" type="button" class="close btn-close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
	<span aria-hidden="true">&times;</span>
</button> -->
<button *ngIf="key" type="button" aria-label="Close" class="btn-close close pull-right" (click)="bsModalRef.hide()">
	<span aria-hidden="true">×</span>
</button>
<iframe class="embed-responsive-item signup-iframe" scrolling="yes" style="min-height: 500px;" [src]="env.host.iframeDomainUrl + 'signup/' + env.domain + env.trafficTag | safeURL" allowfullscreen="true" title="game"></iframe>
</div>

  <!-- Forgot Password -->
<ng-template #forgotPasswordModal>
	<div class="modal-body p-0">
	  <button type="button" class="close btn-close pull-right" aria-label="Close" (click)="modalRef?.hide()">
		<span aria-hidden="true">×</span>
	  </button>
	  <iframe class="embed-responsive-item resetpass-iframe" scrolling="yes" style="min-height: 500px;" [src]="env.host.iframeDomainUrl + 'forgot-password/' +env.domain | safeURL" allowfullscreen="true" title="game"></iframe>
	</div>
  </ng-template>
  <!-- /Forgot Password -->